import type {
  ObjectSchema,
  SchemaDescription,
  SchemaFieldDescription,
  SchemaObjectDescription,
} from 'yup';

export const isFormFieldRequired = (
  name: string,
  schema?: ObjectSchema<object>,
  dependentFieldValues?: Record<string, unknown>,
): boolean => {
  if (!schema) return false;

  const nameParts = name.split('.');
  const fields = schema?.describe({ value: dependentFieldValues }).fields;

  let currentField: SchemaDescription | SchemaFieldDescription | undefined = fields[nameParts[0]];

  for (let i = 1; i < nameParts.length; i++) {
    if (!currentField || currentField.type !== 'object') return false;

    const objectField = currentField as SchemaObjectDescription;
    if (!objectField.fields) return false;

    currentField = objectField.fields[nameParts[i]];
  }

  return testField(currentField);
};

const testField = (field?: SchemaDescription | SchemaFieldDescription) => {
  if (!field) return false;

  if ('tests' in field && 'optional' in field) {
    return Boolean(field.tests.find(t => t.name === 'required')) || !field.optional;
  }

  return false;
};
